module.exports = __webpack_public_path__ + "media/images/article/sum02-0bf7e134942bd516ef4d734dd129a0c0.png";